import { getWindow } from '@vendor/window/window';

export class Capabilities {

    static ualower = getWindow().navigator.userAgent.toLowerCase();
    static isiphone = Capabilities.ualower.indexOf('iphone') > -1;
    static isipad = Capabilities.ualower.indexOf('ipad') > -1;
    static isipod = Capabilities.ualower.indexOf('ipod') > -1;
    static isblackberry = Capabilities.ualower.indexOf('blackberry') > -1;
    static isandroid = Capabilities.ualower.indexOf('android') > -1;
    static ismac = Capabilities.ualower.indexOf('os x') > -1;
    static ischrome = Capabilities.ualower.indexOf('chrome') > -1;

    static isMac(): boolean {
        return (Capabilities.isipad || Capabilities.isiphone
                    || Capabilities.isipod || Capabilities.ismac);
    }

    static isMobile(): boolean {
        return (Capabilities.isipad || Capabilities.isiphone
                    || Capabilities.isipod || Capabilities.isblackberry || Capabilities.isandroid);
    }

    static isIOS(): boolean {
        return (Capabilities.isipad || Capabilities.isiphone || Capabilities.isipod);
    }

    static isIPad(): boolean {
        return Capabilities.isipad;
    }

    static isIPhone(): boolean {
        return Capabilities.isiphone;
    }

    static isIPod(): boolean {
        return Capabilities.isipod;
    }

    static isAndroid(): boolean {
        return Capabilities.isandroid;
    }

    static isChrome(): boolean {
        return Capabilities.ischrome;
    }

    // isBrowser: boolean = typeof document === 'object' && !!document;
    //
    // /** Layout Engines */
    // EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
    // TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
    //
    // // EdgeHTML and Trident mock Blink specific things and need to be excluded from this check.
    // BLINK = this.isBrowser &&
    //   (!!((window as any).chrome || hasV8BreakIterator) && !!CSS && !this.EDGE && !this.TRIDENT);
    //
    // // Webkit is part of the userAgent in EdgeHTML, Blink and Trident. Therefore we need to
    // // ensure that Webkit runs standalone and is not used as another engine's base.
    // WEBKIT = this.isBrowser &&
    //   /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
    //
    // /** Browsers and Platform Types */
    // IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    //
    // // It's difficult to detect the plain Gecko engine, because most of the browsers identify
    // // them self as Gecko-like browsers and modify the userAgent's according to that.
    // // Since we only cover one explicit Firefox case, we can simply check for Firefox
    // // instead of having an unstable check for Gecko.
    // FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
    //
    // // Trident on mobile adds the android platform to the userAgent to trick detections.
    // ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
    //
    // // Safari browsers will include the Safari keyword in their userAgent. Some browsers may fake
    // // this and just place the Safari keyword in the userAgent. To be more safe about Safari every
    // // Safari browser should also use Webkit as its layout engine.
    // SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
}